export const LEAD_STYLE = {
  new: { label: "Nouveau", cls: "bg-[#002FA7] text-white" },
  contacted: { label: "Contacté", cls: "bg-[#0EA5E9] text-white" },
  qualified: { label: "Qualifié", cls: "bg-[#7C3AED] text-white" },
  demo: { label: "Démo", cls: "bg-[#F59E0B] text-white" },
  won: { label: "Gagné", cls: "bg-[#059669] text-white" },
  lost: { label: "Perdu", cls: "bg-[#868E96] text-white" },
};
export const LEAD_ORDER = ["new", "contacted", "qualified", "demo", "won", "lost"];
export const BP_STATUS_STYLE = {
  onboarding: { label: "Onboarding", cls: "bg-[#F59E0B] text-white" },
  active: { label: "Actif", cls: "bg-[#059669] text-white" },
  suspended: { label: "Suspendu", cls: "bg-[#E60000] text-white" },
};
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR") : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const LeadBadge = ({ status, testid }) => {
  const s = LEAD_STYLE[status] || { label: status, cls: "bg-[#868E96] text-white" };
  return <span className={`inline-block text-[9px] uppercase tracking-[0.2em] font-bold px-1.5 py-0.5 ${s.cls}`} data-testid={testid}>{s.label}</span>;
};
